import { DrillField } from '@/types'
import { randElement, randInt } from '@/common'
import { Note, Chord } from 'tonal'

interface TriadParams {
	Chords: Array<'Major' | 'Minor' | 'Diminished' | 'Augmented' | 'Sus2' | 'Sus4'>
	Inversions: Array<'Root' | '1st' | '2nd'>
	Strings: Array<'E' | 'A' | 'D' | 'G'>
}

const chordNames = {
	Major: 'M',
	Minor: 'm',
	Diminished: 'o',
	Augmented: '+',
	Sus2: 'sus2',
	Sus4: 'sus4'
};

(Triads as any).params = [
	{ title: 'Chords', options: ['Major', 'Minor', 'Diminished', 'Augmented', 'Sus2', 'Sus4'] },
	{ title: 'Inversions', options: ['Root', '1st', '2nd'] },
	{ title: 'Strings', options: ['E', 'A', 'D', 'G'] }
]

function Triads(params: TriadParams): DrillField[] {
	const note = Note.from({ step: randInt(0, 6), alt: randInt(-1, 1) })
	const chord = randInt(0, params.Chords.length - 1)
	const inversion = randInt(0, params.Inversions.length - 1)
	let notes = Chord.notes(note, chordNames[params.Chords[chord]])
	if(params.Inversions[inversion] === '1st') {
		notes = [notes[1], notes[2], notes[0]]
	} else if(params.Inversions[inversion] === '2nd') {
		notes = [notes[2], notes[0], notes[1]]
	}
	return [
		{
			label: 'Chord',
			value: `${note} ${params.Chords[chord]}`
		},
		{
			label: 'Inversion',
			value: params.Inversions[inversion]
		},
		{
			label: 'String',
			value: randElement(params.Strings)
		},
		{
			label: 'Notes',
			value: notes.join(' '),
			hide: true
		},
	]
}

export { Triads }
